import * as apis from '@truckdown/jsclient/apis';
import { IAntiforgery } from './IAntiforgery';
import antiForgery from './Antiforgery';

export default (framework: apis.framework.IFramework) => {
    apis.analysis.default(framework);
    apis.tools.default(framework);
    apis.accounts.default(framework);
    apis.tasks.default(framework);

    framework.registerService<IAntiforgery>('IAntiforgery', antiForgery);
}
